import * as echarts from 'echarts/core';
// 按需引入 折线图 和 柱状图
import { BarChart, LineChart, PieChart } from 'echarts/charts';
// 系列类型的定义后缀都为 SeriesOption
import type { BarSeriesOption, LineSeriesOption, PieSeriesOption } from 'echarts/charts';

// 按需引入图表内部组件
import {
  TitleComponent,
  LegendComponent,
  TooltipComponent,
  GridComponent,
  DataZoomInsideComponent,
  // 数据集组件
  DatasetComponent,
  // 内置数据转换器组件 (filter, sort)
  TransformComponent,
} from 'echarts/components';

// 组件的ts类型
import type {
  TitleComponentOption,
  LegendComponentOption,
  TooltipComponentOption,
  GridComponentOption,
  DataZoomComponentOption,
  DatasetComponentOption,
} from 'echarts/components';

// UniversalTransition --- 在切换图表类型时会进行过度动画
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 采用canvas渲染器
import { CanvasRenderer } from 'echarts/renderers';
import type { ComposeOption } from 'echarts/core';

// 通过 ComposeOption 来组合出一个只有必须组件和图表的 Option 类型
export type ECOption = ComposeOption<
  | BarSeriesOption
  | LineSeriesOption
  | TitleComponentOption
  | LegendComponentOption
  | TooltipComponentOption
  | GridComponentOption
  | DataZoomComponentOption
  | DatasetComponentOption
>;

export type SeriesOption = LineSeriesOption | BarSeriesOption | PieSeriesOption;

// 注册必须的组件
echarts.use([
  TitleComponent,
  LegendComponent,
  TooltipComponent,
  GridComponent,
  // DataZoomComponent,
  DataZoomInsideComponent,
  // DataZoomSliderComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  LineChart,
  PieChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
]);

export const setupEcharts = () => ({});

export default echarts;
